import {
  API_URL,
  store
} from '../index'
import axios from 'axios/index'

/* import error handler */
import ErrorHandler from '../ErrorHandler'

/* private Dashboard Types */
import {
  Settings,
  _Dashboard
} from '../namespace-helper'

export default {
  namespaced: true,
  state: {
    weeklyInquiriesStat: []
  },
  mutations: {
    [_Dashboard.mutations.setWeeklyInquiriesStat] (state, payload) {
      state.weeklyInquiriesStat = payload
    }
  },
  actions: {
    [_Dashboard.actions.loadWeeklyInquiresStats] (context, payload) {
      console.log('loadWeeklyInquiresStats: ' + JSON.stringify(payload))

      var url = API_URL + '/api/v1/statistics/getWeeklyInquiries'

      store.commit(Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        context.commit(_Dashboard.mutations.setWeeklyInquiriesStat, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    }
  },
  getters: {
    [_Dashboard.getters.getWeeklyInquiriesStat] (state) {
      return state.weeklyInquiriesStat
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Dashboard/dashboard.js